import { render, staticRenderFns } from "./MedecinDashboard.vue?vue&type=template&id=3628cb46&scoped=true"
import script from "./MedecinDashboard.vue?vue&type=script&lang=js"
export * from "./MedecinDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3628cb46",
  null
  
)

export default component.exports